export default "__VITE_ASSET__hqWbv$bj__"